import {SwapFlowState, SwapFlowStateReducerAction} from "./SwapFlowContext.types";

function swapFlowStateReducer(
  state: SwapFlowState,
  action: SwapFlowStateReducerAction
): SwapFlowState {
  let newState = state;

  switch (action.type) {
    case "SET_VIEW": {
      newState = {
        ...state,
        view: action.view
      };
      break;
    }

    default:
      break;
  }

  return newState;
}

export {swapFlowStateReducer};
